<!-- 头部 -->
<template>
<div class="header">
    <div class="head_tab row">
        <div class="nav-extra-area"></div>
        <div class="nav-link">
            <a v-for="item in menu" :key="item.id" :href="item.attributeValue" target="_blank">{{item.attributeName}}</a>
        </div>
        <div class="nav-extra-area"></div>
    </div>
    <div class="bgcolor">
        <div class="box">
            <div class="menubox">
                <img class="logo" @click="goIndex()" :src="siteLogo ? siteLogo : '/static/images/logo.png'" alt="" srcset="" />
            </div>
            <button class="login" @click="goLogin()" v-if='isshowtx == null'>登录</button>
            <div class="head-avatar" style="margin-top: -10px;" v-if='isshowtx != null'>
                <div class="base_input">
                    <input type="text" placeholder="输入论文标题开始写作" v-model="paperTitle" @keyup.enter="startWriting"/>
                    <img src="/static/images/add_icon.png" @click="startWriting"/>
                </div>
                <div @click="goVip()" class="vip-link">
                    <img src="/static/images/vip_head.png" />
                    <span>
                        {{userinfo.isVip ? "续费": "开通会员"}}
                    </span>
                </div>
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                        <div class="block">
                            <el-avatar :size="50" :src="userinfo.avatarUrl||''"></el-avatar>
                        </div>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class='dropdown-ava'>
                            <!-- <div class="avatar-l">
                                <el-avatar shape="square" :size="50" :src="userinfo.avatarUrl||''"></el-avatar>
                            </div>
                            <div class="avatar-r" >
                                <div class="avatar-r-name">{{userinfo.nickname||''}}</div>
                                <div class="avatar-r-txt" v-show="!userinfo.isVip">未开通会员<span @click="goVip">开通</span></div>
                                <div class="avatar-r-txt" v-show="userinfo.isVip">{{expireTime}}日到期<span @click="goVip">续费</span></div>
                            </div> -->
                        </el-dropdown-item>
                        <el-dropdown-item v-for="item in userNavMenu" :key="item.id"  @click.native="redirect(item.attributeValue)">
                            {{item.attributeName}}
                        </el-dropdown-item>
                        <el-dropdown-item @click.native="logout()">退出登录</el-dropdown-item>
                        <!-- <el-dropdown-item command="/page/Account">账号设置</el-dropdown-item> -->
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>

    <div style="height:70px"></div>

    <!-- 客服 -->
    <!-- <div class="kf-iconr" @click="iskf">
        <img src="/static/images/zhanghu_kefu.png" alt="">
        <span>客服</span>
    </div> -->
    <!-- 打开客服框 -->
    <!-- <div class="kf-box" v-show="iskfBox">
        <div class="kf-close" @click="iskfBox = false" style="text-align: right;cursor: pointer;"><i class="el-icon-close" style="font-size: 20px;"></i></div>
        <div class="kf-box-xbt">意见反馈</div>
        <div class="kf-box-z">在线咨询：<img src="/static/images/vip_erweima.png" alt=""><span>客服微信</span>
            <img :src="contactList.wxUrl" alt="" class="wxImg">
        </div>
        <div class="kf-box-z">欢迎留言吐槽：</div>
        <div class="kf-box-inp">

            <el-input type="textarea" :rows="6" placeholder="请输入反馈内容，内容不要超过500字..." v-model="fkParams.content" class="fk-con">
            </el-input>

            <div class="kf-imgs">
                <el-upload ref="upload" accept=".jpg,.png,.jpeg" :data="feedbackData" action="https://ai-write.oss-cn-hangzhou.aliyuncs.com" :show-file-list="false" :limit="1" :on-success="feedbackSuccess" :before-upload="feedbackUpload">
                    <el-input readonly class="fk-con" v-model="fkParams.images"></el-input>
                    <img src="/static/images/zhanghu_tupian.png" alt="">
                </el-upload>
            </div>
        </div>
        <el-input v-model="fkParams.contact" placeholder="您的邮箱或者QQ号"></el-input>
        <span style="font-size: 12px; color: #FF5959;" v-if="qq_error">*请输入正确的QQ号码或者邮箱</span>
        <div class="kf-zy">注：客服小姐姐收到留言后会根据邮箱或者QQ联系您</div>
        <div class="kf-btn" @click="feedback">发送</div>
    </div> -->
  
     <RechargePop :visible.sync="dialogVisible"></RechargePop> 
      <!-- 成功弹窗 -->
    <el-dialog :visible.sync="vipPop" width="430px" center>
        <div class="modifyM-box" style="text-align: center; width:370px;height:183px">
            <div class="vip-suc">
                <img src="../../static/images/acc_state_sucess.png" alt=""/>
                <p style="margin-top:32px;font-size:17px;color:#333439;font-weight:bold">支付成功</p>
            </div>
        </div>
    </el-dialog>

</div>
</template>

<script>
import RechargePop from './recharge/rechargePop.vue';
export default {
    components: {
        RechargePop
    },
    data() {
        return {
            activeName: "",
            iskfBox: false, // 是否打开客服框
            // 反馈意见
            fkParams: {
                category: 4, // 用户反馈类型
                contact: '', // 联系方式
                content: '', // 反馈内容
                images: '', // 图片（地址）
                terminal: 1, // 反馈终端
                userId: '' // 用户id
            },
            qq_error: false,
            contactList: {},
            feedbackData: {}, // 上传图片时额外参数（图片的信息）
            menu: [],
            isshowtx: localStorage.getItem("token"),
            userinfo: {},
            // vip到期时间
            expireTime: '2020-10-30',
            userNavMenu: [],
            siteLogo: "",
            indexPage: "",
            paperTitle: "",
            dialogVisible: false,
            vipPop: false
        };
    },
    created: function () {
        this.activeName = this.$route.name;
        this.userinfo = JSON.parse(localStorage.getItem("userinfo")) || {}
        if (this.userinfo != null && this.userinfo.expireTime != null) {
            this.expireTime = this.userinfo.expireTime.split(' ')[0] || ''
        }
        //this.getContact()
    },

    mounted: function() {
        this.getSiteLogo();
        this.getIndexPage();
        this.getNavigationHead();
        this.getNavigationUser();
    },

    methods: {
        // 客服
        iskf() {
            this.iskfBox = true // 打开客服框
        },
        /**
         *跳转页面 控制导航栏激活
         */
        handleClick: function (val) {
            this.$router.push(this.menu[val.index].path);
        },
        feedback() {
            var qq = /^[1-9]\d{4,9}$/
            var email = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
            console.log(this.fkParams.contact, email.test(this.fkParams.contact))
            if (qq.test(this.fkParams.contact) || email.test(this.fkParams.contact)) {
                console.log('通过')
                this.qq_error = false
            } else {
                this.qq_error = true
                return false
            }

            this.fkParams.userId = localStorage.getItem('userId')
            this.oauthapi.feedback(this.fkParams).then(res => {
                if (res.code == 0) {
                    this.iskfBox = false
                    this.fkParams.contact = ''
                    this.fkParams.content = ''
                    this.fkParams.images = ''
                    this.$message(res.msg)
                }
            })
        },
        // 微信二维码
        getContact() {
            this.oauthapi.contact().then(res => {
                this.contactList = res.data
            })
        },
        // 反馈图片上传成功的钩子
        feedbackSuccess(response, file, fileList) {
            this.$message({
                message: '上传成功',
                type: 'success'
            })
        },
        // 传图片之前的钩子
        async feedbackUpload(file) {
            const isLt500K = file.size / 1024 / 1024 < 0.5
            // 不可超过500K
            if (!isLt500K) {
                this.$message.error('上传图片大小不能超过 500K!')
            } else {
                let picSuffix = {
                    picSuffix: file.name.split('.')[1] // 图片格式后缀
                }
                // 调用获取反馈图片上传oss信息接口
                // res：响应参数
                await this.oauthapi.feedbackOss(picSuffix).then(res => {
                    this.feedbackData.ossid = res.data.ossid
                    this.feedbackData.key = res.data.ossKey
                    this.feedbackData.policy = res.data.policy
                    this.feedbackData.ossAccessKeyId = res.data.ossAccessKeyId
                    this.feedbackData.signature = res.data.signature
                    this.fkParams.images = res.data.ossurl + '/' + res.data.ossKey // 反馈图片
                })
            }
            return isLt500K
        },
        /**
         *点击登录
         */
        goLogin: function () {
            this.$router.push({
                name: "login",
                query: {
                    path: this.$route.path,
                    params: this.$route.params,
                    query: this.$route.query
                }
            });
        },
        /**
         *跳转首页
         */
        goIndex: function () {
            // this.$router.push("/");
            this.redirect(this.indexPage);
        },
        // 跳转至会员中心
        goVip() {
            // this.oauthapi.vipRedirectUrl().then(res => {
            //     if(res.code == 0) {
            //         window.open(res.data.attributeValue, "_blank");
            //     }
            // })

            this.dialogVisible = true;
        },
        // 账号设置
        handleCommand(command) {
            if (command == '/page/Account') {
                this.$router.push(command)
            } else if (command == '/home') {
                localStorage.clear();
                location.reload()
                this.$router.push(command)
            }

        },
        //获取用户导航栏
        getNavigationUser() {
            this.api.getNavigationUser().then(res => {
                if (res.code == 0) {
                    this.userNavMenu = res.data;
                }
            })
        },
        //获取头部导航栏
        getNavigationHead() {
            this.api.getNavigationHead().then(res => {
                if(res.code == 0) {
                    this.menu = res.data;
                }
            })
        },
        //获取平台logo
        getSiteLogo() {
            this.api.getSiteLogo().then(res => {
                if (res.code == 0) {
                    this.siteLogo = res.data.attributeValue;
                }
            })
        },
        //获取业务平台首页地址
        getIndexPage() {
            this.api.getIndexPage({code:"LOGIN_URL"}).then(res => {
                if (res.code == 0) {
                    this.indexPage = res.data.attributeValue;
                }
            })
        },

        //url 跳转
        redirect(href) {
            window.open(href, "_blank");
        },
        //退出登录
        logout() {
            //清空本地存储
            this.api.getIndexPage({code:"LOGOUT_URL"}).then(res => {
                if (res.code == 0) {
                    window.localStorage.clear();
                    window.location.href = res.data.attributeValue;
                }
            })
        },
        //开始写作
        startWriting() {
            if ( this.paperTitle.trim().length < 5) {
                this.$message({
                    message: "论文标题需不少于5个字",
                    type: "warning"
                })
                return false;
            }
            if (this.paperTitle.trim().length > 51) {
                 this.$message({
                    message: "论文标题需不多于50个字",
                    type: "warning"
                })
                return false;
            }
            let params = {
                title: this.paperTitle,
                content: '',
            }
            this.api.create(params).then((res) => {
                if (res.code == 0) {
                    this.gowriting(res.data.id)
                }
            })
        },
        gowriting: function (id) {

            this.$router.push({
                name: 'editor',
                query: {
                    id: id,
                }
            })
        },
        closeRechargePop(dialogVisible) {
            this.dialogVisible = dialogVisible;
        },
        paySuccess(vipPop) {
            this.dialogVisible = false;
            this.vipPop = vipPop;
            // 更新用户信息
            this.oauthapi.userInfo().then(res => {
                this.userinfo = res.data;
            });
        }
    },
    watch: {
        $route: {
            /**
             *  监听路由变化 导航栏高亮以及取消高亮
             *   val; 新路由信息
             *   oldval 老路由信息
             *
             */
            handler: function (val, oldval) {
                this.activeName = val.name;
                this.iskfBox = false
                this.isshowtx = localStorage.getItem('token')
                if (!localStorage.getItem('token')) {
                    this.$root.stateType.isLogin = false
                }

            },
            // 深度观察监听
            deep: true
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
// /deep/ .el-dialog__header{
//     padding: 0;
// }

// /deep/ .el-dialog__body {
//     padding: 0;
// }

.head-avatar {
    cursor: pointer;
}

.header {
    .bgcolor {
        width: 100%;
        // background: #ffffff;
        background: #5A7ABD;
        position: fixed;
        height: 50px;
        z-index: 99;
        padding-top: 60px;
    }

    .box {
        margin: 0 auto;
        width: $mWidth;
        display: flex;
        justify-content: space-between;

        .menubox {
            display: flex;

            .item {
                margin: 0 28px;
                font-size: 16px;
                color: $tabc;
                background: none;
                border: none;
                outline: none;
            }

            .item:active {
                color: #999999;
            }

            .logo {
                height: 30px;
                margin-right: 60px;
                cursor: pointer;
            }
        }

        .login {
            width: 102px;
            color: #ffffff;
            height: 33px;
            background: $btnc;
            opacity: 1;
            border-radius: 20px;
            border: none;
            font-size: 16px;
            line-height: 33px;
            z-index: 9;
            cursor: pointer;
        }
    }

    .head_tab{
        display: flex;
        position: fixed;
        justify-content: space-between;
        top: 0;
        min-width: $mWidth;
        width: 100%;
        height: 40px;
        line-height: 40px;
        background: #ffffff;
        z-index: 999;
        .nav-link{
            width: 1200px;
            a {
                display: inline-block;
                margin-right: 20px;
                color: #333;
                cursor: pointer;
            }
        }
        .nav-extra-area{
            width: 10px;
        }
       
    }
}

.head-avatar{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 460px;
    .base_input {
        border-radius: 30px;
        height: 30px;
        border: 1px solid #cccccc;
        padding: 0 10px;
        display: flex;
        align-items: center;
        width: 240px;
        background: #dedede;
        input {
            border: none;
            background-color: #dedede;
            width: 100%;
        }

        input::-webkit-input-placeholder,
        input::-moz-placeholder,
        input:-moz-placeholder,
        input:-ms-input-placeholder {
            color: red;
        }

        img {
            height: 21px;
            margin-left: 5px;
        }
    }
    .vip-link{
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #ffffff;
        img{
            padding-right: 5px;
        }
    }
}

.dropdown-ava {
    overflow: hidden;
    padding-top: 10px;
}

.avatar-l {
    float: left;
}

.avatar-r {
    float: left;
    margin-left: 10px;
    line-height: 25px;

    .avatar-r-txt {
        span {
            margin-left: 10px;
            color: #C79757;
            cursor: pointer;
        }
    }
}

.kf-iconr {
    position: absolute;
    background: #5576BD;
    width: 80px;
    height: 40px;
    line-height: 40px;
    background: #5576BD;
    border-radius: 20px 0px 0px 20px;
    position: fixed;
    right: -40px;
    bottom: 40%;
    color: #fff;
    text-align: center;
    z-index: 9;
    cursor: pointer;

    &:hover {
        right: 0;
    }

    img {
        vertical-align: middle;
    }

    span {
        margin-left: 5px;
    }
}

.kf-box {
    width: 340px;
    position: fixed;
    right: 0;
    bottom: 30%;
    padding: 20px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px 0px 0px 4px;
    color: #66686E;
    z-index: 9;

    .kf-box-xbt {
        font-size: 16px;
        color: #333439;
        border-bottom: 1px solid #EEEEEE;
        line-height: 40px;
        margin-bottom: 10px;
    }

    .kf-box-z {
        line-height: 30px;
        cursor: pointer;

        &:nth-child(2) {
            cursor: pointer;
        }

        img {
            vertical-align: middle;
        }

        span {
            margin-left: 5px;
        }

        .wxImg {
            width: 9rem;
            height: 9rem;
            display: none;
            position: absolute;
            z-index: 2;
            margin-left: 70px;
        }

        &:hover {
            .wxImg {
                display: block;
            }
        }
    }

    .kf-box-inp {
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        margin-bottom: 20px;

        .fk-con {
            >>>.el-textarea__inner {
                border: 0;
            }

            >>>.el-input__inner {
                border: 0 !important;
                width: 185%;
            }

        }

        .kf-imgs {
            position: relative;

            img {
                position: absolute;
                right: 6px;
                top: 14px;
                cursor: pointer;
            }
        }
    }

    .kf-zy {
        color: #FF5959;
        font-size: 12px;
        margin-top: 10px;
    }

    .kf-btn {
        background: #5576BD;
        width: 100px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        color: #fff;
        font-size: 18px;
        border-radius: 17px;
        margin: 15px 0 0;
        float: right;
        right: 0;
        cursor: pointer;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/header.vue